import React, { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import AccordionSection from "./AccordionSection";
import ProjectInfo from "./ProjectInfo";
import VisibilityControl from "./VisibilityControl";
import "./Sidebar.css";

const Sidebar: React.FC = () => {
  const [openSections, setOpenSections] = useState({
    projectInfo: true,
    visibilityControl: true,
  });
  const { t } = useLanguage();

  const toggleSection = (section: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className="pc-side">
      <AccordionSection
        title={t("project_info")}
        isOpen={openSections.projectInfo}
        onToggle={() => toggleSection("projectInfo")}
      >
        <ProjectInfo />
      </AccordionSection>

      <AccordionSection
        title={t("visibility_control")}
        isOpen={openSections.visibilityControl}
        onToggle={() => toggleSection("visibilityControl")}
      >
        <VisibilityControl />
      </AccordionSection>
    </div>
  );
};

export default Sidebar;
